export function tryParseFloat(val) {
  if (/^-?\d*\.?\d*$/.test(val)) {
    const parsedVal = parseFloat(val);
    if (!isNaN(parsedVal)) {
      val = parsedVal;
    }
  }

  return val;
}

export function floatToPercent(n: number): string {
  n *= 10000;
  n = Math.round(n);
  n /= 100;
  n = `${n}%`;
  return n;
}
